import LocomotiveScroll from 'locomotive-scroll';
import { ScrollTrigger } from 'gsap/all';
const locomotiveInit = () => {
  return new Promise((resolve) => {
    const scrollContainer = document.querySelector("[data-scroll-container]");

    const scroll = new LocomotiveScroll({
      el: scrollContainer,
      smooth: true,
      direction: 'vertical',
      lerp: 0.075
    });

    ScrollTrigger.scrollerProxy(scrollContainer, {
      scrollTop(value) {
        return arguments.length
          ? scroll.scrollTo(value, 0, 0)
          : scroll.scroll.instance.scroll.y;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight
        };
      },
      pinType: document.querySelector("[data-scroll-container]").style.transform
      ? "transform"
      : "fixed"
    });

    scroll.on('scroll', ScrollTrigger.update);

    ScrollTrigger.addEventListener('refresh', () => scroll.update());
    ScrollTrigger.refresh();

    resolve();

    setTimeout(() => {
        scroll.update();
      }, 5000);

      let lastScrollY = 0;

    scroll.on('scroll', (obj) => {
        const nav = document.querySelector('.header');
        const currentScrollY = obj.scroll.y; 
        
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
            nav.classList.add('hide'); 
        } else {
            nav.classList.remove('hide');
        }
      
        lastScrollY = currentScrollY;
    });
  });

  
};
export default locomotiveInit;